// SECTION: Imports
import React from "react";
import { motion } from "framer-motion";

// SECTION: Component
export default function AnimatedPhoneIcon({ size = 220 }) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: size,
        aspectRatio: "100 / 190",
        position: "relative"
      }}
    >

      {/* SECTION: Phone outline */}
      <motion.svg
        viewBox="0 0 100 190"
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0
        }}
      >
        <defs>
          <linearGradient id="phoneStroke" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#7b59ff" />
            <stop offset="100%" stopColor="#6bbcff" />
          </linearGradient>
        </defs>

        <motion.rect
          x="2%"
          y="2%"
          width="96%"
          height="96%"
          rx="12%"
          stroke="url(#phoneStroke)"
          strokeWidth="1.5"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.1, ease: "easeInOut" }}
        />

        {/* notch */}
        <motion.rect
          x="32"
          y="4"
          width="36"
          height="10"
          rx="4"
          fill="#7b59ff"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.9 }}
          transition={{ delay: 0.7, duration: 0.35 }}
        />
      </motion.svg>

      {/* SECTION: Screen background */}
      <div
        style={{
          position: "absolute",
          top: "2%",
          left: "2%",
          width: "96%",
          height: "96%",
          borderRadius: "12%",
          background:
            "linear-gradient(160deg, rgba(123,89,255,0.22), rgba(107,188,255,0.20))"
        }}
      />

      {/* SECTION: Lock icon */}
      <motion.div
        style={{
          position: "absolute",
          top: "12%",
          width: "100%",
          textAlign: "center",
          fontSize: "12px",
          color: "#7b59ff"
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.0, duration: 0.4 }}
      >
        🔒
      </motion.div>

      {/* SECTION: Time */}
      <motion.div
        style={{
          position: "absolute",
          top: "19%",
          width: "100%",
          textAlign: "center",
          fontSize: "22px",      // now proportional and readable but NOT oversized
          fontWeight: 300,
          color: "#7b59ff"
        }}
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.5 }}
      >
        11:42
      </motion.div>

      {/* SECTION: Notification */}
<motion.div
  initial={{ y: -12, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ delay: 2.0, duration: 0.45 }}
  style={{
    position: "absolute",
    top: "38%",

    /* WIDER container — still safe */
    width: "88%",
    left: "6%",
    overflow: "hidden",

    borderRadius: "14px",
    boxShadow: "0 8px 22px rgba(0,0,0,0.14)",
    backdropFilter: "blur(14px)",
    background: "rgba(255,255,255,0.30)"
  }}
>
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      padding: "8px 10px",
      gap: "8px",
      width: "100%",
      boxSizing: "border-box"
    }}
  >
    {/* ICON */}
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: "6px",
        overflow: "hidden",
        flexShrink: 0
      }}
    >
      <img
        src="/assets/icon_transparent.png"
        alt="Panacea Icon"
        style={{ width: "100%", height: "100%" }}
      />
    </div>

    {/* TEXT */}
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          fontWeight: 700,
          fontSize: "10px",
          color: "#5a2ff5",
          lineHeight: 1.22
        }}
      >
        GAD-7 Survey
      </div>

      {/* <div
        style={{
          fontSize: "11px",
          color: "#5a2ff5",
          opacity: 0.85,
          lineHeight: 1.18
        }}
      >
        Please complete.
      </div> */}
    </div>
  </div>
</motion.div>

    </div>
  );
}
